<h1 mat-dialog-title>
  <span transloco="BULK_CSV_UPDATE_DOCUMENTS"></span>
</h1>
<div mat-dialog-content>
  <mat-stepper
    linear
    #stepper
    (selectionChange)="onStepSelectionChange($event)"
  >
    <mat-step [completed]="csvUploadStepCompleted" [editable]="stepIsEditable">
      <form [formGroup]="csvFileUploadFormGroup">
        <ng-template matStepLabel>{{ 'CHOOSE_A_CSV' | transloco }}</ng-template>
        <mat-form-field class="input-padding">
          <mat-label>CSV File</mat-label>
          <ngx-mat-file-input
            accept=".csv"
            formControlName="csvFile"
          ></ngx-mat-file-input>
        </mat-form-field>
        <mat-checkbox
          formControlName="containsColumnHeaders"
          class="checkbox-left-margin"
          >{{ 'CSV_CONTAINS_COLUMN_HEADERS' | transloco }}</mat-checkbox
        >
        <div>
          <mat-form-field class="csv-options-field" appearance="outline">
            <input
              matInput
              type="text"
              maxlength="1"
              formControlName="columnDelimiter"
            />
            <mat-hint
              >{{ 'COLUMN' | transloco }}
              {{ 'DELIMITER' | transloco }}</mat-hint
            >
          </mat-form-field>
          <mat-form-field
            class="csv-options-field delimiter-margin"
            appearance="outline"
          >
            <input
              matInput
              type="text"
              maxlength="1"
              formControlName="stringDelimiter"
            />
            <mat-hint>{{ 'STRING_DELIMITER' | transloco }}</mat-hint>
          </mat-form-field>
        </div>
      </form>
    </mat-step>
    <mat-step
      #csvFieldMappingStep
      [hasError]="csvFieldMappingStep.interacted && !gridDataValid()"
      [completed]="gridDataValid()"
      [editable]="stepIsEditable"
    >
      <ng-template matStepLabel
        ><span>{{ 'MAP_CSV_FIELDS' | transloco }}</span></ng-template
      >
      <form [formGroup]="csvFieldMappingFormGroup">
        <div [ngClass]="{ 'full-panel-width': stepper.selectedIndex === 2 }">
          <mat-checkbox
            class="margin-top"
            formControlName="overwriteSystemFields"
          >
            <span transloco="OVERWRITE_SYSTEM_FIELDS"></span>
          </mat-checkbox>
          <ag-grid-angular
            #grid
            class="ag-theme-material grid-height"
            [gridOptions]="gridOptions"
          ></ag-grid-angular>

          @if (!this.archiveIdMapped || !this.documentIdMapped) {
            <div class="mapper-error-container">
              <p
                transloco="ARCHIVEID_AND_DOCID_MUST_BE_MAPPED_TO_CONTINUE."
              ></p>
            </div>
          }
        </div>
      </form>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>
        {{ 'UPDATE' | transloco }}
      </ng-template>
      @if (status === statusEnums.confirm) {
        <div>
          <mat-dialog-content>
            <h2 transloco>CONFIRM</h2>
            <span> {{ 'ARE_YOU_SURE_CSV_UPDATE' | transloco }}</span>
          </mat-dialog-content>
        </div>
      }
      @if (status === statusEnums.updating) {
        <div>
          <mat-dialog-content class="align-center">
            <h2 transloco>UPDATING_</h2>
            <mat-progress-bar
              class="margin-bottom"
              [mode]="'determinate'"
              [value]="progress"
            >
            </mat-progress-bar>
            <span>{{ currentDocument }} / {{ totalDocuments }}</span>
          </mat-dialog-content>
        </div>
      }
      @if (status === statusEnums.complete && erroredRows === 0) {
        <div>
          <mat-dialog-content class="align-center">
            <h2 transloco>COMPLETE</h2>
            <span
              >{{ currentDocument }} of {{ totalDocuments }} processed.</span
            >
          </mat-dialog-content>
        </div>
      }
      @if (status === statusEnums.complete && erroredRows > 0) {
        <div>
          <mat-dialog-content class="align-center">
            <h2>{{ 'COMPLETED_WITH_ERRORS' | transloco }}</h2>
            <p>{{ currentDocument }} of {{ totalDocuments }} processed.</p>
            <p>
              {{ 'BULK_CSV_UPDATE_COMPLETED_WITH_ERRORS' | transloco }}
              <button mat-button (click)="onClickDownloadResults()">
                <span transloco="DOWNLOAD_PACKAGE"></span>
              </button>
            </p>
          </mat-dialog-content>
        </div>
      }
      @if (status === statusEnums.cancel) {
        <div>
          <mat-dialog-content class="align-center">
            <h2 transloco>CANCELLED</h2>
            <span>{{ currentDocument }} of {{ totalDocuments }} updated.</span>
          </mat-dialog-content>
        </div>
      }
    </mat-step>
  </mat-stepper>
</div>
<div mat-dialog-actions align="end">
  @if (status !== statusEnums.updating) {
    <button mat-button type="button" (click)="onClose()">
      <span transloco="CLOSE"></span>
    </button>
  }
  @if (status === statusEnums.updating) {
    <button mat-button type="button" (click)="onCancel()">
      <span transloco="CANCEL"></span>
    </button>
  }
  @if (status === statusEnums.confirm) {
    <button mat-button (click)="onReset()" type="button">
      <span transloco="RESET"></span>
    </button>
  }
  @if (stepper.selectedIndex === 1) {
    <button
      mat-button
      (click)="onClickToggleIncludeAll(!atLeastOneFieldIncluded)"
    >
      <span
        transloco="{{
          atLeastOneFieldIncluded
            ? 'EXCLUDE_ALL_COLUMNS'
            : 'INCLUDE_ALL_COLUMNS'
        }}"
      ></span>
    </button>
  }
  <span class="spacer"></span>
  @if (stepper.selectedIndex === 0) {
    <button
      mat-button
      (click)="onStartUpload()"
      [disabled]="csvFileUploadFormGroup.invalid"
    >
      <span transloco="UPLOAD"></span>
    </button>
  }
  @if (
    stepper &&
    stepper.selectedIndex > 0 &&
    status !== statusEnums.complete &&
    status !== statusEnums.updating
  ) {
    <button
      mat-button
      [disabled]="currentStepInvalid"
      (click)="stepper.previous()"
    >
      <span transloco="BACK"></span>
    </button>
  }
  @if (showGoToNextStep) {
    <button
      mat-button
      [disabled]="
        currentStepInvalid || (disableUpdate && stepper.selectedIndex === 1)
      "
      (click)="stepper.next()"
    >
      <span transloco="NEXT"></span>
    </button>
  }
  @if (stepper.selectedIndex === 2 && status === statusEnums.confirm) {
    <button
      mat-button
      [disabled]="disableStartUpdate"
      (click)="onUpdateDocuments()"
    >
      <span transloco="UPDATE_DOCUMENTS"></span>
    </button>
  }
</div>
